/* SMS attribution: seven days, latest click, Shopify marketing permission. */
(function () {
  'use strict';
  if (window.NexoSmsAttribution) return;

  var STORAGE_KEY = 'nexo_sms_attribution_v1';
  var TTL_SECONDS = 7 * 24 * 60 * 60;
  var enteredMs = Date.now(), enteredAt = Math.floor(enteredMs / 1000);
  var incoming = '';
  try { incoming = new URLSearchParams(location.search).get('vcid') || ''; } catch (error) {}
  if (!/^[a-f0-9]{20}$/i.test(incoming)) incoming = '';
  incoming = incoming.toLowerCase();

  var current = null, landingConsumed = false, mustClear = false, storageCleared = false;
  var previousPermission = null, lastSynced = '', inFlight = null, queued = false;
  var consentState = null, consentAt = 0;
  var retrySignature = '', refreshTimer = null;
  var resumingForms = new WeakSet(), pendingForms = new WeakSet();

  function permission() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return privacy && typeof privacy.marketingAllowed === 'function' ? privacy.marketingAllowed() === true : null;
    } catch (error) { return null; }
  }

  function valid(record) {
    if (!record || typeof record.key !== 'string' || !/^[a-f0-9]{20}$/i.test(record.key)) return false;
    var stamp = Number(record.capturedAt), now = Math.floor(Date.now() / 1000);
    return Number.isInteger(stamp) && stamp > 0 && stamp <= now + 300 && now - stamp <= TTL_SECONDS;
  }

  function validConsentAt(value) {
    var stamp = Number(value);
    return /^\d{13}$/.test(String(value)) && Number.isInteger(stamp)
      && stamp <= Math.floor(Date.now() / 1000) * 1000 + 999;
  }

  function observeConsent(allowed, stored) {
    var state = allowed ? 'granted' : 'denied';
    if (consentState !== state) {
      var observed = Date.now();
      // Navigation may retain an already observed grant; a click time is never consent evidence.
      if (consentState === null && !mustClear && allowed && stored && validConsentAt(stored.consentAt)) observed = stored.consentAt;
      if (consentState !== null) { observed = Math.max(observed, consentAt + 1); mustClear = true; }
      consentAt = observed;
      consentState = state;
    } else if (allowed && stored && validConsentAt(stored.consentAt) && stored.consentAt > consentAt) {
      consentAt = stored.consentAt;
    }
  }

  function consentValues() {
    // A storage removal is not evidence of the time at which permission was revoked.
    if (storageCleared || permission() === null) return { state: 'denied', at: '' };
    return { state: consentState || 'denied', at: consentAt ? String(consentAt) : '' };
  }

  function saved() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var record = JSON.parse(raw);
      if (valid(record)) {
        var seconds = Number(record.capturedAt), milliseconds = Number(record.capturedMs);
        if (!Number.isInteger(milliseconds) || Math.floor(milliseconds / 1000) !== seconds) milliseconds = seconds * 1000;
        return { key: record.key.toLowerCase(), capturedAt: seconds, capturedMs: milliseconds,
          consentAt: validConsentAt(record.consentAt) ? Number(record.consentAt) : 0 };
      }
      localStorage.removeItem(STORAGE_KEY);
      mustClear = true;
    } catch (error) {
      if (raw) { try { localStorage.removeItem(STORAGE_KEY); mustClear = true; } catch (storageError) {} }
    }
    return null;
  }

  function refresh() {
    var allowed = permission();
    if (allowed === null) return null;
    if (!allowed) {
      observeConsent(false, null);
      storageCleared = false;
      if (current || previousPermission === true) mustClear = true;
      try { if (localStorage.getItem(STORAGE_KEY)) mustClear = true; localStorage.removeItem(STORAGE_KEY); } catch (error) {}
      current = null;
      if (previousPermission === true) landingConsumed = true;
      previousPermission = false;
      return null;
    }

    // Another tab cannot turn a cleared attribution back into a grant through storage alone.
    if (storageCleared && previousPermission !== false) return null;
    if (previousPermission === false) storageCleared = false;
    if (current && !valid(current)) { current = null; mustClear = true; }
    var stored = saved();
    observeConsent(true, stored);
    previousPermission = true;
    if (stored && (!current || stored.capturedMs >= current.capturedMs)) current = stored;
    if (incoming && !landingConsumed) {
      landingConsumed = true;
      if (!current || enteredMs >= current.capturedMs) current = { key: incoming, capturedAt: enteredAt, capturedMs: enteredMs };
    }
    if (current) {
      current.consentAt = consentAt;
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(current)); } catch (error) {}
    }
    return current;
  }

  function attributeValues(record) {
    var consent = consentValues();
    return {
      __vcid: record ? record.key : '',
      __vcid_captured_at: record ? String(record.capturedAt) : '',
      __vcid_consent: consent.state,
      __vcid_consent_at: consent.at
    };
  }

  function formKind(form) {
    if (!form || form.tagName !== 'FORM') return '';
    try {
      var url = new URL(form.getAttribute('action') || location.href, location.origin);
      if (url.origin !== location.origin) return '';
      if (/\/cart\/add(?:\.js)?\/?$/.test(url.pathname)) return 'product';
      if (/\/cart(?:\.js)?\/?$/.test(url.pathname)) return 'cart';
    } catch (error) {}
    return '';
  }

  function formValues(form, record) {
    var kind = formKind(form), values = {}, consent = consentValues();
    if (kind === 'product' && record) {
      values['properties[_vcid]'] = record.key;
      values['properties[_vcid_captured_at]'] = String(record.capturedAt);
    }
    if (kind === 'product' && (permission() !== null || storageCleared)) {
      values['properties[_vcid_consent]'] = consent.state;
      values['properties[_vcid_consent_at]'] = consent.at;
    } else if (kind === 'cart' && (record || mustClear || permission() === false || storageCleared)) {
      var attributes = attributeValues(record);
      Object.keys(attributes).forEach(function (key) { values['attributes[' + key + ']'] = attributes[key]; });
    }
    return values;
  }

  function updateForm(form, record) {
    var values = formValues(form, record);
    form.querySelectorAll('input[data-nexo-sms]').forEach(function (input) {
      if (!Object.prototype.hasOwnProperty.call(values, input.name)) input.remove();
    });
    Object.keys(values).forEach(function (name) {
      var input = form.querySelector('input[name="' + name + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden'; input.name = name;
        input.setAttribute('data-nexo-sms', '1');
        form.appendChild(input);
      }
      if (input.value !== values[name]) input.value = values[name];
    });
  }

  function updateForms(record) {
    document.querySelectorAll('form[action]').forEach(function (form) {
      if (formKind(form)) updateForm(form, record);
    });
  }

  function cartRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return typeof root === 'string' && root.charAt(0) === '/' && root.charAt(1) !== '/' ? root : '/';
  }

  function request(url, options) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer;
    var timeout = new Promise(function (_, reject) {
      timer = setTimeout(function () {
        if (controller) controller.abort();
        reject(new Error('SMS attribution timeout'));
      }, 1800);
    });
    var config = Object.assign({ credentials: 'same-origin' }, options || {});
    if (controller) config.signal = controller.signal;
    var operation = Promise.resolve().then(function () { return fetch(url, config); })
      .then(function (response) { if (!response.ok) throw new Error('SMS attribution HTTP'); return response.json(); });
    return Promise.race([operation, timeout])
      .finally(function () { clearTimeout(timer); });
  }

  function syncOnce() {
    var record = refresh();
    updateForms(record);
    if (permission() === null || (!record && !mustClear)) return Promise.resolve(true);
    return request(cartRoot() + 'cart.js', { cache: 'no-store' }).then(function (cart) {
      if (!cart || Number(cart.item_count || 0) < 1) return true;
      record = refresh();
      if (permission() === null || (!record && !mustClear)) return true;
      var values = attributeValues(record);
      var signature = String(cart.token || '') + '|' + JSON.stringify(values);
      if (signature === lastSynced) return true;
      return request(cartRoot() + 'cart/update.js', {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: values })
      }).then(function () {
        lastSynced = signature;
        retrySignature = '';
        // A consent change or newer click during this request must be sent next.
        var latest = refresh();
        if (JSON.stringify(attributeValues(latest)) !== JSON.stringify(values)) queued = true;
        else if (!latest) mustClear = false;
        return true;
      });
    }).catch(function () {
      var signature = JSON.stringify(attributeValues(refresh()));
      if (retrySignature !== signature) {
        retrySignature = signature;
        setTimeout(sync, 600);
      }
      return false;
    });
  }

  function sync() {
    queued = true;
    if (inFlight) return inFlight;
    function drain() {
      queued = false;
      return syncOnce().then(function (result) { return queued ? drain() : result; });
    }
    inFlight = drain().catch(function () { return false; }).finally(function () { inFlight = null; });
    return inFlight;
  }

  function beforeCheckout() {
    // Tracking must never strand a buyer when the network is unavailable.
    if (permission() === false) mustClear = true;
    return new Promise(function (resolve) {
      var settled = false;
      var timer = setTimeout(finish, 1200);
      function finish() { if (settled) return; settled = true; clearTimeout(timer); resolve(); }
      sync().then(finish, finish);
    });
  }

  function onSubmit(event) {
    var form = event.target, kind = formKind(form);
    if (!kind) return;
    var record = refresh();
    updateForm(form, record);
    if (kind !== 'cart' || !event.submitter || event.submitter.name !== 'checkout' || resumingForms.has(form)) return;
    if (!record && !mustClear && permission() !== false) return;
    event.preventDefault();
    if (pendingForms.has(form)) return;
    pendingForms.add(form);
    beforeCheckout().then(function () {
      pendingForms.delete(form);
      updateForm(form, refresh());
      resumingForms.add(form);
      try {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(event.submitter);
        else {
          var checkout = document.createElement('input');
          checkout.type = 'hidden'; checkout.name = 'checkout'; checkout.value = 'checkout';
          form.appendChild(checkout);
          HTMLFormElement.prototype.submit.call(form);
        }
      } catch (error) {
        window.location.assign(cartRoot() + 'checkout');
      } finally { resumingForms.delete(form); }
    });
  }

  function onCheckoutClick(event) {
    if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target && event.target.closest && event.target.closest('a[href]');
    if (!link || link.getAttribute('target') === '_blank' || link.hasAttribute('download')) return;
    var url;
    try { url = new URL(link.getAttribute('href'), location.origin); } catch (error) { return; }
    if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    var record = refresh();
    if (!record && !mustClear && permission() !== false) return;
    event.preventDefault();
    beforeCheckout().then(function () { window.location.assign(url.href); });
  }

  function refreshFormsSoon() {
    if (refreshTimer) return;
    refreshTimer = setTimeout(function () { refreshTimer = null; updateForms(refresh()); }, 80);
  }

  function bind() {
    updateForms(refresh());
    sync();
    document.addEventListener('visitorConsentCollected', function () {
      if (permission() !== null) {
        if (storageCleared) { consentState = null; consentAt = 0; mustClear = true; }
        storageCleared = false;
      }
      updateForms(refresh()); sync();
    });
    document.addEventListener('shopifyCustomerPrivacyApiLoaded', sync);
    document.addEventListener('cart:updated', sync);
    document.addEventListener('cart:product-added', sync);
    document.addEventListener('submit', onSubmit, true);
    document.addEventListener('click', onCheckoutClick, true);
    document.addEventListener('formdata', function (event) {
      if (!event.formData || !formKind(event.target)) return;
      var values = formValues(event.target, refresh());
      ['properties[_vcid]', 'properties[_vcid_captured_at]', 'properties[_vcid_consent]', 'properties[_vcid_consent_at]',
        'attributes[__vcid]', 'attributes[__vcid_captured_at]', 'attributes[__vcid_consent]', 'attributes[__vcid_consent_at]'].forEach(function (name) {
        event.formData.delete(name);
      });
      Object.keys(values).forEach(function (name) { event.formData.set(name, values[name]); });
    });
    window.addEventListener('storage', function (event) {
      if (event.key !== STORAGE_KEY && event.key !== null) return;
      if (event.newValue === null) {
        current = null; landingConsumed = true; mustClear = true; storageCleared = true;
      }
      sync();
    });
    window.addEventListener('pageshow', sync);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, sync);
    if (typeof MutationObserver === 'function') new MutationObserver(refreshFormsSoon).observe(document.body, { childList: true, subtree: true });
    if (permission() === null && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], sync); } catch (error) {}
    }
  }

  window.NexoSmsAttribution = { sync: sync, beforeCheckout: beforeCheckout };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
  else bind();
})();
